import apiSlice from "../api/apiSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userList: builder.mutation({
      query: () => ({
        url: "/admin/user/list",
        method: "POST",
      }),
    }),
    userInfo: builder.query({
      query: (id) => ({
        url: `/user/view/${id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),

    // create subadmin
    createSubadmin: builder.mutation({
      query: (data) => ({
        url: `/subadmin/add-new`,
        body: data,
        method: "POST",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    updateSubadmin: builder.mutation({
      query: (data) => ({
        url: `/subadmin/update`,
        body: data,
        method: "POST",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),

    deleteSubadmin: builder.mutation({
      query: (id) => ({
        url: `/subadmin/remove/${id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    approveKyc: builder.mutation({
      query: ({ id, page }) => ({
        url: `/user/approve-kyc/${id}/${page}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    rejectKyc: builder.mutation({
      query: ({ id, page, reason }) => ({
        url: `/user/reject-kyc/${id}/${page}`,
        method: "POST",
        body: { reason: reason },
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    getSubadminList: builder.query({
      query: () => ({
        url: `/subadmin/list`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    getSingleSubadminDetails: builder.query({
      query: (id) => ({
        url: `/subadmin/details/${id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    getUniqueId: builder.query({
      query: () => ({
        url: `/unique_id`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    getAllNft: builder.query({
      query: () => ({
        url: `/admin/shownft`,
        method: "POST",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    getSingleUserNft: builder.query({
      query: (id) => ({
        url: `/admin/shownft`,
        method: "POST",
        body: { id },
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/user/delete/${id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    //settings
    settings: builder.mutation({
      query: () => ({
        url: `/site/list`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    updateSettings: builder.mutation({
      query: (_id) => ({
        url: `/site/update`,
        method: "POST",
        body: _id,
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    // Transaction Report
    transcationReport: builder.mutation({
      query: ({ type }) => ({
        url: "/admin/transcation_report",
        method: "POST",
        body: { type },
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    //transctionhistory
    transctionhistory: builder.mutation({
      query: () => ({
        url: `/admin/transcationshistory`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    singletransctionhistory: builder.mutation({
      query: (_id) => ({
        url: `/admin/viewtranscations/${_id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    //user showtranscationhistory
    userShowtranscationhistory: builder.query({
      query: (id) => ({
        url: `/admin/showtranscationshistory`,
        body: { id },
        method: "POST",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    //unblock/block user
    unblockblockUser: builder.mutation({
      query: ({ id }) => ({
        url: `/user/change/${id}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    changeMode: builder.mutation({
      query: ({ id, mode }) => ({
        url: `/admin/changemode/${id}`,
        method: "POST",
        body: { mode },
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    //referal-history
    referalHistory: builder.query({
      query: (data) => ({
        url: "/referral/history",
        method: "POST",
        body: { type: data },
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    // ROI history
    roiHistory: builder.query({
      query: () => ({
        url: "/getroireport",
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
    changeKyc: builder.mutation({
      query: ({ id, page, body }) => ({
        url: `/user/change-kyc/${id}/${page}`,
        method: "GET",
        headers: {
          Tag: "admin",
          Authorization: `${localStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const {
  useUserListMutation,
  useUserInfoQuery,
  useUserDeleteQuery,
  useCreateSubadminMutation,
  useApproveKycMutation,
  useRejectKycMutation,
  useUpdateSubadminMutation,
  useGetSubadminListQuery,
  useGetUniqueIdQuery,
  useGetAllNftQuery,
  useGetSingleUserNftQuery,
  useGetSingleSubadminDetailsQuery,
  useDeleteSubadminMutation,
  useDeleteUserMutation,
  useSettingsMutation,
  useUpdateSettingsMutation,
  useUnblockblockUserMutation,
  useTransctionhistoryMutation,
  useSingletransctionhistoryMutation,
  useUserShowtranscationhistoryQuery,
  useChangeModeMutation,
  useRoiHistoryQuery,
  useChangeKycMutation,
  useReferalHistoryQuery,
  useTranscationReportMutation,
} = userApi;
